import FAQSection from "@components/Pages/Studio/PricingPage/FAQSection/FAQSection"
import PackagesSection from "@components/Pages/Studio/PricingPage/PackagesSection/PackagesSection"
import HeadMeta from "@components/Theme/HeadMeta/HeadMeta"
import getValueOrThrow from "@helpers/getValueOrError"
import {getLink} from "@hooks/PagesData/getLink"
import {getTranslatedPageData} from "@hooks/PagesData/getTranslatedPageData"
import OnePricingHome from "@jsons/OnePricingHome.json"
import React from "react"

type Props = {}

const home = (props: Props) => {
	const pageData = getTranslatedPageData(OnePricingHome, undefined, true)
	const mainContent = getValueOrThrow(pageData.AdvancedSideAsset)

	return (
		<>
			<HeadMeta
				meta={pageData.metaData}
				customPath={"/pricing/one/home"}
			/>
			<PackagesSection
				cards={getValueOrThrow(pageData.pricingCardData)}
				data={mainContent[0]}
				disableCurency
				best={1}
				plans={[
					{
						link: getLink("pricingOneEnterprise"),
						title: "Business Plans",
					},
					{
						link: getLink("pricingOneHome"),
						title: "Home Plans",
					},
				]}
			/>

			<FAQSection
				faq={getValueOrThrow(pageData.faqData)}
				pageData={mainContent[1]}
			/>
		</>
	)
}

export default home
